import { BetaFeatures } from 'apps/login/consts';

export const isElevatedLoginEnabled = (customerBetaFeatures) => {
  const betaFeatures = customerBetaFeatures || [];
  return betaFeatures.includes(BetaFeatures.LOGIN_ELEVATED_RAVEN) &&
    !betaFeatures.includes(BetaFeatures.SSO_ELEVATED_LOGIN);
};
